module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-visitor-ui": "static-1.29471",
      "ably": "static-2.2",
      "data-fetching-client": "static-1.9699",
      "ably-hubspot-js": "static-2.4749",
      "atom": "static-1.5106",
      "conversations-error-reporting": "static-1.8919",
      "conversations-internal-pub-sub": "static-1.16012",
      "conversations-internal-schema": "static-1.12958",
      "conversations-message-history": "static-1.12805",
      "conversations-test-sdk": "static-1.10536",
      "conversations-visitor-experience-components": "static-1.22834",
      "head-dlb": "static-1.5007",
      "hs-promise-utils": "static-1.5623",
      "hs-test-utils": "static-1.8047",
      "hubspot-dlb": "static-2.1854",
      "HubStyleTokens": "static-2.11505",
      "I18n": "static-7.1631",
      "immer": "static-1.33",
      "jasmine-immutable": "static-1.3053",
      "jasmine-runner": "static-1.6496",
      "quartz": "static-1.7071",
      "react-dlb": "static-1.79",
      "react-select-plus": "static-1.105",
      "react-transition-group": "static-2.65",
      "redux-thunk": "static-2.43",
      "sanitize": "static-1.4508",
      "StyleGuideUI": "static-3.488",
      "transmute": "static-2.85",
      "urlinator": "static-1.4569",
      "usage-tracker": "static-1-cwunder-lower-max-network-payload-size.9",
      "usage-tracker-core": "static-1-cwunder-lower-max-network-payload-size.9",
      "usage-tracker-public": "static-1-cwunder-lower-max-network-payload-size.9",
      "viral-links-lib": "static-1.7100",
      "visitor-ui-component-library": "static-1.6171",
      "webpack-env": "static-1.54",
      "autolinker": "static-3.11",
      "classnames": "static-2.10",
      "conversations-http": "static-1.4846",
      "conversations-prop-types": "static-1.7484",
      "conversations-visitor-message-history": "static-1.21571",
      "cssUtils": "static-1.798",
      "enviro": "static-4.455",
      "flux-actions": "static-1.341",
      "foundations-components": "static-1.7998",
      "hs-lodash": "static-4.45",
      "hub-http": "static-1.6255",
      "hubspot-url-utils": "static-1.4132",
      "immutable": "static-2.79",
      "metrics-js": "static-1.9637",
      "PatternValidationJS": "static-1.437",
      "PortalIdParser": "static-2.404",
      "raven": "static-3.5925",
      "react": "static-7.186",
      "react-aria": "static-1.66",
      "react-dom": "static-7.85",
      "react-redux": "static-7.71",
      "react-rhumb": "static-1.16706",
      "react-utils": "static-2.5369",
      "redux": "static-4.16",
      "redux-toolkit": "static-1.7",
      "reselect": "static-2.16",
      "sanitize-text": "static-1.8175",
      "signup-constants": "static-1.18900",
      "styled-components": "static-2.89",
      "usage-tracker-multi": "static-1-cwunder-lower-max-network-payload-size.9",
      "visitor-ui-component-library-icons": "static-1.5982",
      "hs-promise-rejection-tracking": "static-1.5587",
      "raven-hubspot": "static-1.6232",
      "hoist-non-react-statics": "static-3.9",
      "bend-plugin-trellis-migration": "static-1.3424",
      "moment": "static-3.26",
      "apollo-stack-hubspot": "static-3.86",
      "fast-json-stable-stringify": "static-1.4",
      "graphql": "static-1.82",
      "quartz-config": "static-1.849",
      "quartz-core": "static-1.6290",
      "foundations-assets": "static-1.4901",
      "foundations-theming": "static-1.4452",
      "UIComponents": "static-3.8451",
      "conversations-async-data": "static-2.7695",
      "customer-data-email": "static-1.18089",
      "cv-backend-services": "static-1.1553",
      "immutable-less": "static-1.4685",
      "conversations-skeleton-state": "static-1.7280",
      "crm-events-viz-core": "static-1.33305",
      "customer-data-objects": "static-1.7706",
      "icons": "static-2.650",
      "react-immutable-proptypes": "static-2.8",
      "react-input-autosize": "static-2.17",
      "rpc-client-utils": "static-1.4685",
      "ui-images": "static-2.1160",
      "HeadJS": "static-2.764",
      "framer-motion": "static-1.72",
      "hs-test-utils-bend-plugin": "static-1.3158",
      "msw": "static-1.39",
      "testing-library": "static-1.152",
      "i18n-data": "static-1.221",
      "moment-timezone": "static-5.83",
      "jasmine": "static-4.4359",
      "signup-ui-url-generator": "static-2.8086",
      "HubStyle": "static-2.11812",
      "quartz-i18n": "static-1.746",
      "sassPrefix": "static-1.156",
      "bend-plugin-foundations-components": "static-1.4267",
      "floating-ui": "static-1.56",
      "foundations-theming-specialty": "static-1.2168",
      "hs-story-utils": "static-1.9456",
      "react-create-root-preference": "static-1.29",
      "react-virtualized": "static-2.99",
      "tanstack-table": "static-1.55",
      "trellis-assets": "static-1.2038",
      "ui-fonts": "static-1.767",
      "hs-locale-management": "static-1.106",
      "csstype": "static-1.50",
      "quartz-head": "static-1.736",
      "quick-fetch": "static-1.3941",
      "web-vitals": "static-1.6",
      "quartz-routing": "static-1.501",
      "usage-tracker-anonymous": "static-1-cwunder-lower-max-network-payload-size.9",
      "bender-build-tools": "static-1.3227",
      "dispatcher": "static-1.137",
      "general-store": "static-6.20",
      "hub-http-janus": "static-1.838",
      "hubspotter-http": "static-1.4676",
      "mobile-manifest-mixins": "static-1.538",
      "module-federation": "static-1.23",
      "quartz-auth": "static-1.746",
      "quartz-test": "static-1.746",
      "quartz-tracking": "static-1.450",
      "usage-tracker-container": "static-1-cwunder-lower-max-network-payload-size.9",
      "bend-plugin-foundations-theming": "static-1.2935",
      "foundations-theming-base": "static-1.3437",
      "stylex": "static-1.33",
      "apollo-dlb": "static-3.86",
      "apollo-link-hub-http": "static-2.4684",
      "customer-data-ui-utilities": "static-1.9858",
      "FileManagerCore": "static-1.39218",
      "FileManagerLib": "static-1.39359",
      "hubspot-apollo-client": "static-1.4911",
      "react-immutable-render-mixin": "static-1.9",
      "salesImages": "static-1.525",
      "timezone-utils": "static-2.5277",
      "ui-gdpr-components": "static-1.10383",
      "ts-schema": "static-1.4105",
      "ai-components-ui-library": "static-1.9061",
      "avatar-components": "static-1.2531",
      "content-assistance-lib": "static-1.7800",
      "crm-component-utils": "static-1.39182",
      "crm-display-components": "static-1.24932",
      "crm-fe-perf": "static-1.22936",
      "crm-links": "static-1.6333",
      "crm-message-bus": "static-1.43071",
      "crm-search-service-types": "static-1.1187",
      "crm-source-interpretation-lib": "static-1.5376",
      "customer-data-communicator": "static-1.45650",
      "customer-data-filters-ui": "static-1.39932",
      "customer-data-objects-ui-components": "static-1.13062",
      "customer-data-properties": "static-1.51697",
      "customer-data-rte": "static-1.33097",
      "draft-plugins": "static-2.21731",
      "file-manager-components": "static-1.23719",
      "framework-data-schema-resolvers": "static-1.6918",
      "frontend-preferences-client": "static-1.7960",
      "hubspot-prosemirror": "static-1.18336",
      "object-comments-thread-lib": "static-1.10762",
      "prosemirror-user-and-team-at-mentions": "static-1.673",
      "reference-resolvers-lite": "static-1.8128",
      "ui-addon-upgrades": "static-9.18046",
      "universal-associations-select": "static-1.11072",
      "universal-record-utils-lib": "static-1.1015",
      "wootric-nps": "static-1.7006",
      "inbound-db-properties-service-client": "static-1.3871",
      "property-translator": "static-1.5431",
      "bend-plugin-chirp-manifest": "static-1.95",
      "chirp-fetch": "static-1.1920",
      "hub-http-shared-msw-handlers": "static-1.10050",
      "hubspotter-http-shared-msw-handlers": "static-1.10048",
      "usage-tracker-session-replay": "static-1-cwunder-lower-max-network-payload-size.9",
      "react-dnd-compat": "static-1.4647",
      "audio-components": "static-1.5963",
      "cropperjs": "static-1.10",
      "feedback-loader": "static-1.29358",
      "FileManagerImages": "static-1.36870",
      "foundations-components-legacy": "static-1.1023",
      "immerable": "static-1.4186",
      "react-colorpicker": "static-2.10240",
      "ui-universal-auth": "static-1.9016",
      "video-components": "static-1.13417",
      "video-data-lib": "static-1.35072",
      "video-embed": "static-1.35906",
      "hubspot-apollo-cache": "static-1.370",
      "chatspot-core": "static-1.21442",
      "ContentUtils": "static-1.68476",
      "copilot-toolkit": "static-1.11224",
      "superstore": "static-1.4793",
      "ui-addon-video-player": "static-1.8735",
      "ui-coaching-tips": "static-1.28667",
      "card-properties-lib": "static-1.44308",
      "commerce-subscription-lib": "static-1.37232",
      "crm-actions": "static-1.6365",
      "crm-cards-sdk": "static-1.43703",
      "customer-data-properties-shared-msw-handlers": "static-1.9377",
      "customer-data-property-utils": "static-1.8124",
      "customer-data-tracking": "static-1.6922",
      "hs-resources": "static-1.189",
      "inbound-db-meta-service-client": "static-1.3611",
      "pulse": "static-1.612",
      "framework-data-table": "static-2.11996",
      "location-customization-utils-lib": "static-1.9375",
      "restore-request-side-panel-lib": "static-1.997",
      "calling-error-reporting": "static-1.31342",
      "calling-internal-common": "static-1.31335",
      "calling-usage-tracker": "static-1.6573",
      "crm_data": "static-4.92081",
      "customer-data-content": "static-1.27348",
      "draft-content-plugins": "static-1.28369",
      "draft-convert": "static-2.73",
      "draft-extend": "static-3.75",
      "draft-js": "static-5.78",
      "draft-signature-plugin": "static-1.24169",
      "EmailSignatureEditor": "static-1.24450",
      "hubspot-prosemirror-plugins": "static-1.18328",
      "integration-settings-components": "static-1.15581",
      "integrations-lib": "static-1.16286",
      "integrations-tracking-lib": "static-1.5635",
      "native-integrations-shared-strings": "static-1.7814",
      "nav-meta": "static-1.29767",
      "onboarding-scopes": "static-1.6493",
      "outreach-assistant-email-generation": "static-1.6292",
      "prosemirror-copilot": "static-1.11711",
      "prosemirror": "static-1.13",
      "quotes-client-types": "static-1.38258",
      "reference-resolvers": "static-1.8204",
      "rich-text-lib": "static-1.19888",
      "sales-email-signature-service-client": "static-1.3877",
      "sequences-lib": "static-1.8099",
      "ui-addon-i18n": "static-1.11181",
      "ui-addon-iframeable": "static-1.9093",
      "ui-business-units-lib": "static-1.9089",
      "ui-shepherd-react": "static-3.10205",
      "user-context": "static-1.5138",
      "whatsapp-sending-lib": "static-1.5821",
      "events-data-lib": "static-1.258",
      "customer-data-filters-ui-msw-helpers": "static-1.22367",
      "customer-data-reference-ui-components": "static-1.13199",
      "FormUrlGenerator": "static-2.4751",
      "framework-builder-read-service-client": "static-1.4030",
      "framework-data-schema-quick-fetch": "static-1.6823",
      "multi-account-reference-resolvers": "static-1.1013",
      "onboarding-tours": "static-1.16672",
      "reporting-datasets-permissions-lib": "static-1.13788",
      "SharedI18nStrings": "static-1.182",
      "ui-addon-teams": "static-1.21603",
      "calling-global-api": "static-1.64637",
      "calling-lifecycle-internal": "static-1.66019",
      "calling-lifecycle-messages": "static-1.58313",
      "commerce-products-lib": "static-1.9701",
      "conditional-properties-service-client": "static-1.3822",
      "external-options-client-types": "static-1.4184",
      "google-libphonenumber": "static-1.38",
      "inbounddb-objects-service-types": "static-1.4248",
      "meetings-icalendar-utils-lib": "static-1.664",
      "multi-currency-client-types": "static-1.3716",
      "object-builder-ui-client": "static-1.48873",
      "pipeline-validation-client-types": "static-1.3990",
      "property-value-citations": "static-1.2311",
      "smart-property-lib": "static-1.7275",
      "tiered-pricing": "static-1.1296",
      "zustand": "static-1.74",
      "ui-addon-form-validation": "static-1.11022",
      "video-components-external": "static-1.11414",
      "batch-promise": "static-1.1574",
      "crm-pipelines-api-client-types": "static-1.4164",
      "fdsr-migration-layer": "static-1.37",
      "persist-promise": "static-1.3731",
      "emoji-mart": "static-3.4",
      "growth-payments-core": "static-1.25489",
      "knowledge-content-types": "static-1.8504",
      "payment-link-components": "static-1.23622",
      "ui-addon-emoji-picker": "static-1.9920",
      "call-summary": "static-1.39327",
      "reference-resolvers-lite-shared-msw-handlers": "static-1.10196",
      "laboratory-lib": "static-3.7188",
      "merchandise-lib": "static-1.264",
      "purchase-motions-components": "static-1.5979",
      "crm-object-search-query-utilities": "static-1.9653",
      "amplitude-session-replay-browser": "static-1.60",
      "react-dnd": "static-5.6",
      "react-dnd-html5-backend": "static-5.6",
      "unified-auth-core-lib": "static-1.812",
      "content-icons-ui": "static-1.2233",
      "social-insights-client-types": "static-1.22215",
      "outpost": "static-1.4211",
      "markdown-it": "static-1.6",
      "cms-field-types": "static-1.4845",
      "underscore": "static-1.8",
      "magpie-lib": "static-1.5572",
      "magpie-types": "static-1.5032",
      "simple-logging-lib": "static-1.3083",
      "growth-onboarding-feedback-components": "static-1.6612",
      "customer-data-sidebar": "static-2.46122",
      "enrichment-properties-lib": "static-1.16393",
      "ui-addon-draggable-compat": "static-2.4289",
      "commerce-billing-lib": "static-1.19193",
      "commerce-shared-components-lib": "static-1.18634",
      "commerce-tools-ui-lib": "static-1.10477",
      "bend-plugin-pulse": "static-1.115",
      "event-emitter": "static-1.980",
      "fast-json-patch": "static-1.63",
      "customer-data-associations": "static-1.7359",
      "reporting-data": "static-1.67711",
      "tanstack-virtual": "static-1.30",
      "ui-addon-draggable": "static-3.4795",
      "crm-record-cards-service-types": "static-1.3615",
      "self-service-api": "static-1.10280",
      "crm_universal": "static-1.22062",
      "SalesContentIndexUI": "static-3.9300",
      "content-embed-lib": "static-1.7371",
      "data-model-builder-lib": "static-1.12459",
      "remote-ui": "static-1.65",
      "ui-components-test-utils": "static-1.5642",
      "ui-extensions-remote-renderer": "static-1.17126",
      "universal-page-editor-lib": "static-1.3046",
      "integrations-error-boundary-lib": "static-1.13701",
      "redux-observable": "static-1.11",
      "ReduxMessenger": "static-2.10398",
      "rxjs": "static-5.10",
      "unified-auth": "static-1.530",
      "messaging-types-lib": "static-1.46121",
      "ai-addon-copilot-preview": "static-1.8273",
      "copilot-plugins": "static-1.11197",
      "data-token-picker": "static-1.16462",
      "sequences-client-types-lib": "static-1.7956",
      "foundations-components-test-utils": "static-1.5481",
      "navigation-messaging": "static-1.7457",
      "getting-started-shared-tasks": "static-1.18550",
      "getting-started-shared-tasks-store": "static-1.17668",
      "onboarding-tours-utils": "static-1.738",
      "messaging-usage-based-billing-components-lib": "static-1.1246",
      "whatsapp-management-lib": "static-1.8980",
      "growth-data-modal": "static-1.5477",
      "growth-onboarding-confetti": "static-1.3099",
      "growth-onboarding-next-action-utils": "static-1.2031",
      "navigation-components": "static-1.18130",
      "onboarding-tours-client": "static-1.4886",
      "ui-shepherd-tracker": "static-1.7586",
      "shared-worker-versioning": "static-1.11069",
      "voice-sms-access-library": "static-1.1149",
      "commerce-permissions": "static-1.805",
      "products-iframe-lib": "static-1.8040",
      "products-ui-components-shared-msw-handlers": "static-1.10432",
      "data-agent-kit": "static-1.244",
      "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10133",
      "fsm": "static-1.3764",
      "policy-lib": "static-1.6809",
      "react-tinymce": "static-1.55351",
      "tinymce": "static-5.11",
      "tinymce-config": "static-2.54477",
      "tinymce-plugins": "static-1.57591",
      "tinymce-themes": "static-1.56447",
      "content-media-composition-data-lib": "static-1.12455",
      "content-media-compositions": "static-2.16462",
      "idb-keyval": "static-1.44",
      "media-bridge-lib": "static-1.18981",
      "seat-types-lib": "static-1.96",
      "ui-addon-opt": "static-4.8395",
      "commerce-tours-lib": "static-1.6166",
      "growth-onboarding-reliability": "static-1.5114",
      "sales-checkout-service-client": "static-1.3675",
      "calling-cross-tab-library": "static-1.19320",
      "calling-lifecycle-usage-tracker": "static-1.8805",
      "purchase-motions-api": "static-1.5982",
      "reactive-lib": "static-1.755",
      "card-payment-highlight-lib": "static-1.37286",
      "card-subscription-highlight-lib": "static-1.39655",
      "commerce-contract-lib": "static-1.12219",
      "invoices-highlight-card-lib": "static-1.54843",
      "orders-highlight-card-lib": "static-1.21573",
      "products-highlight-card-lib": "static-1.17984",
      "quotes-highlight-card-lib": "static-1.72168",
      "usage-based-billing-components-lib": "static-1.9078",
      "utility-belt": "static-1.2566",
      "payments-enrollment-embed-lib": "static-1.23009",
      "stripe-embedded-components": "static-1.7561",
      "growth-onboarding-empty-states": "static-1.5796",
      "InboxConnectUtils": "static-4.14918",
      "payments-post-enroll-local-storage-lib": "static-1.5141",
      "qrcode-generator": "static-1.69",
      "trials-service-types": "static-1.3937",
      "reporting-client-types": "static-1.2508",
      "react-flip-move": "static-1.70",
      "FireAlarmUi": "static-1.4537",
      "sales-templates-service-types-lib": "static-1.4195",
      "ui-asset-management-lib": "static-1.11082",
      "association-settings-lib": "static-1.10389",
      "collaboration-sidebar": "static-1.57918",
      "conditional-property-settings-modal": "static-1.12524",
      "data-model-commons-lib": "static-1.12722",
      "ExportDialog": "static-6.10417",
      "final-form": "static-1.70",
      "html-to-image": "static-1.54",
      "nudge-client-utils": "static-1.2656",
      "object-definition-builder-lib": "static-1.7136",
      "property-management-iframe": "static-1.13281",
      "property-usages-lib": "static-1.5473",
      "reactflow": "static-1.64",
      "simple-data-table": "static-1.2885",
      "used-in-list-lib": "static-1.6991",
      "visual-association": "static-1.5917",
      "highcharts": "static-8.104",
      "reporting-visualizations": "static-1.59787",
      "ui-extensibility-client-types": "static-1.3957",
      "google-sheets-integration-lib": "static-1.351",
      "microsoft-drive-integration-lib": "static-1.477",
      "slack-ui-library": "static-1.10425",
      "automation-platform-service-types": "static-1.2598",
      "ContentData": "static-1.68551",
      "email-portal-health-service-types": "static-1.1011",
      "marketing-email-service-types": "static-1.1928",
      "ai-rendering-library": "static-1.10297",
      "ai-settings-ui-library": "static-1.7934",
      "breeze-engine-lib": "static-1.760",
      "ui-brand-identity-lib": "static-1.15434",
      "messaging-shared-utils-lib": "static-1.695",
      "messaging-user-info-utils-lib": "static-1.865",
      "content-whatsapp-service-types": "static-1.410",
      "marketing-platform-lib": "static-1.6891",
      "short-messages-app-service-client": "static-1.4002",
      "ui-tool-access": "static-1.10180",
      "onboarding-data-sync-lib": "static-1.2006",
      "growth-onboarding-next-action-components": "static-1.2059",
      "user-context-client": "static-1.4644",
      "nest": "static-1.262",
      "calling-orchestration-schema": "static-1.35926",
      "sales-views-client-types": "static-1.4292",
      "trellis-story-utils": "static-1.4547",
      "storybook-react": "static-1.33",
      "hub-http-contrib": "static-1.3074",
      "interframe": "static-3.4792",
      "tinymce-data": "static-1.40562",
      "ui-addon-sales-email": "static-1.5243",
      "codemirror": "static-5.95",
      "layout-dnd-components": "static-1.12505",
      "layout-dnd-utils": "static-1.11480",
      "react-codemirror": "static-1.10658",
      "NamespacedHubStyle": "static-2.9083",
      "js-cookie": "static-1.18",
      "products-ui-components": "static-1.40219",
      "accounting-integrations-ui-components": "static-1.7114",
      "invoices-ui-lib": "static-1.54859",
      "commerce-products-api": "static-1.2350",
      "invoices-iframe-lib": "static-1.56917",
      "quotes-modal-lib": "static-1.102846",
      "quotes-ui-lib": "static-1.80889",
      "platform-infra-nav-components": "static-1.7696",
      "reporting-ui-components": "static-2.64982",
      "subscription-experience-data-types": "static-1.14977",
      "marketplace-ui-apps-core": "static-1.18419",
      "stripe-connect-js": "static-1.69",
      "ui-addon-react-router-dom": "static-1.9574",
      "nested-table": "static-1.259",
      "chatspot-widget-iframe": "static-1.21433",
      "collaboration-sidebar-common": "static-1.2715",
      "crm-properties-common-lib": "static-1.5918",
      "nudge-custom-function-registry": "static-1.2413",
      "nudge-renderer-utils": "static-1.2732",
      "whisper-core-api": "static-1.6733",
      "property-management-common": "static-1.5569",
      "d3": "static-1.7",
      "advanced-menus-core": "static-1.15177",
      "advanced-menus-lib": "static-1.12115",
      "ui-memberships-settings-lib": "static-1.34152",
      "breeze-onboarding-components": "static-1.100",
      "embedded-academy-lib": "static-1.14443",
      "highlight.js": "static-1.79",
      "reporting-action-components": "static-1.41402",
      "reporting-snowflake": "static-1.56329",
      "meetings-connect-utils-lib": "static-1.7637",
      "diff-match-patch": "static-1.7",
      "layout-data-lib": "static-1.9805",
      "browser-eslint": "static-2.57",
      "commerce-tax-lib": "static-1.561",
      "price-books-api": "static-1.930",
      "price-books-components": "static-1.988",
      "property-description-translator": "static-1.3875",
      "ramp-editor": "static-1.230",
      "commerce-analytics-service-client": "static-1.3663",
      "totals-ui-components": "static-1.23710",
      "reporting-plugins": "static-1.10375",
      "reporting-reports": "static-1.67389",
      "edison-service-client-types": "static-1.422",
      "developer-experience-shared-components": "static-1.10544",
      "marketplace-ui-client-types": "static-1.17294",
      "marketplace-ui-common": "static-1.19887",
      "ui-addon-integrations-directory-panel": "static-2.8032",
      "react-window": "static-1.13",
      "ts-utils-lib": "static-1.204",
      "seamless-immutable": "static-7.6",
      "simple-menus-core": "static-1.15176",
      "simple-menus-lib": "static-1.16693",
      "academy-common-lib": "static-1.13903",
      "dashboard-lib": "static-1.81674",
      "share-with-third-party-component-lib": "static-1.8735",
      "line-items-api": "static-1.750",
      "commerce-totals-service-types": "static-1.3844",
      "campaign-roi-lib": "static-1.9229",
      "apps-service-types": "static-1.3910",
      "oauth-service-types": "static-1.4284",
      "academy-service-client": "static-1.3715",
      "croppie": "static-2.10",
      "trellis-ecosystem": "static-1.7200",
      "redux-actions": "static-3.7"
    },
    "depPathPrefixes": {
      "conversations-visitor-ui": "/conversations-visitor-ui/static-1.29471",
      "ably": "/ably/static-2.2",
      "data-fetching-client": "/data-fetching-client/static-1.9699",
      "ably-hubspot-js": "/ably-hubspot-js/static-2.4749",
      "atom": "/atom/static-1.5106",
      "conversations-error-reporting": "/conversations-error-reporting/static-1.8919",
      "conversations-internal-pub-sub": "/conversations-internal-pub-sub/static-1.16012",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.12958",
      "conversations-message-history": "/conversations-message-history/static-1.12805",
      "conversations-test-sdk": "/conversations-test-sdk/static-1.10536",
      "conversations-visitor-experience-components": "/conversations-visitor-experience-components/static-1.22834",
      "head-dlb": "/head-dlb/static-1.5007",
      "hs-promise-utils": "/hs-promise-utils/static-1.5623",
      "hs-test-utils": "/hs-test-utils/static-1.8047",
      "hubspot-dlb": "/hubspot-dlb/static-2.1854",
      "HubStyleTokens": "/HubStyleTokens/static-2.11505",
      "I18n": "/I18n/static-7.1631",
      "immer": "/immer/static-1.33",
      "jasmine-immutable": "/jasmine-immutable/static-1.3053",
      "jasmine-runner": "/jasmine-runner/static-1.6496",
      "quartz": "/quartz/static-1.7071",
      "react-dlb": "/react-dlb/static-1.79",
      "react-select-plus": "/react-select-plus/static-1.105",
      "react-transition-group": "/react-transition-group/static-2.65",
      "redux-thunk": "/redux-thunk/static-2.43",
      "sanitize": "/sanitize/static-1.4508",
      "StyleGuideUI": "/StyleGuideUI/static-3.488",
      "transmute": "/transmute/static-2.85",
      "urlinator": "/urlinator/static-1.4569",
      "usage-tracker": "/usage-tracker/static-1-cwunder-lower-max-network-payload-size.9",
      "usage-tracker-core": "/usage-tracker-core/static-1-cwunder-lower-max-network-payload-size.9",
      "usage-tracker-public": "/usage-tracker-public/static-1-cwunder-lower-max-network-payload-size.9",
      "viral-links-lib": "/viral-links-lib/static-1.7100",
      "visitor-ui-component-library": "/visitor-ui-component-library/static-1.6171",
      "webpack-env": "/webpack-env/static-1.54",
      "autolinker": "/autolinker/static-3.11",
      "classnames": "/classnames/static-2.10",
      "conversations-http": "/conversations-http/static-1.4846",
      "conversations-prop-types": "/conversations-prop-types/static-1.7484",
      "conversations-visitor-message-history": "/conversations-visitor-message-history/static-1.21571",
      "cssUtils": "/cssUtils/static-1.798",
      "enviro": "/enviro/static-4.455",
      "flux-actions": "/flux-actions/static-1.341",
      "foundations-components": "/foundations-components/static-1.7998",
      "hs-lodash": "/hs-lodash/static-4.45",
      "hub-http": "/hub-http/static-1.6255",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
      "immutable": "/immutable/static-2.79",
      "metrics-js": "/metrics-js/static-1.9637",
      "PatternValidationJS": "/PatternValidationJS/static-1.437",
      "PortalIdParser": "/PortalIdParser/static-2.404",
      "raven": "/raven/static-3.5925",
      "react": "/react/static-7.186",
      "react-aria": "/react-aria/static-1.66",
      "react-dom": "/react-dom/static-7.85",
      "react-redux": "/react-redux/static-7.71",
      "react-rhumb": "/react-rhumb/static-1.16706",
      "react-utils": "/react-utils/static-2.5369",
      "redux": "/redux/static-4.16",
      "redux-toolkit": "/redux-toolkit/static-1.7",
      "reselect": "/reselect/static-2.16",
      "sanitize-text": "/sanitize-text/static-1.8175",
      "signup-constants": "/signup-constants/static-1.18900",
      "styled-components": "/styled-components/static-2.89",
      "usage-tracker-multi": "/usage-tracker-multi/static-1-cwunder-lower-max-network-payload-size.9",
      "visitor-ui-component-library-icons": "/visitor-ui-component-library-icons/static-1.5982",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
      "raven-hubspot": "/raven-hubspot/static-1.6232",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3424",
      "moment": "/moment/static-3.26",
      "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.86",
      "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
      "graphql": "/graphql/static-1.82",
      "quartz-config": "/quartz-config/static-1.849",
      "quartz-core": "/quartz-core/static-1.6290",
      "foundations-assets": "/foundations-assets/static-1.4901",
      "foundations-theming": "/foundations-theming/static-1.4452",
      "UIComponents": "/UIComponents/static-3.8451",
      "conversations-async-data": "/conversations-async-data/static-2.7695",
      "customer-data-email": "/customer-data-email/static-1.18089",
      "cv-backend-services": "/cv-backend-services/static-1.1553",
      "immutable-less": "/immutable-less/static-1.4685",
      "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7280",
      "crm-events-viz-core": "/crm-events-viz-core/static-1.33305",
      "customer-data-objects": "/customer-data-objects/static-1.7706",
      "icons": "/icons/static-2.650",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "rpc-client-utils": "/rpc-client-utils/static-1.4685",
      "ui-images": "/ui-images/static-2.1160",
      "HeadJS": "/HeadJS/static-2.764",
      "framer-motion": "/framer-motion/static-1.72",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3158",
      "msw": "/msw/static-1.39",
      "testing-library": "/testing-library/static-1.152",
      "i18n-data": "/i18n-data/static-1.221",
      "moment-timezone": "/moment-timezone/static-5.83",
      "jasmine": "/jasmine/static-4.4359",
      "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8086",
      "HubStyle": "/HubStyle/static-2.11812",
      "quartz-i18n": "/quartz-i18n/static-1.746",
      "sassPrefix": "/sassPrefix/static-1.156",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4267",
      "floating-ui": "/floating-ui/static-1.56",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2168",
      "hs-story-utils": "/hs-story-utils/static-1.9456",
      "react-create-root-preference": "/react-create-root-preference/static-1.29",
      "react-virtualized": "/react-virtualized/static-2.99",
      "tanstack-table": "/tanstack-table/static-1.55",
      "trellis-assets": "/trellis-assets/static-1.2038",
      "ui-fonts": "/ui-fonts/static-1.767",
      "hs-locale-management": "/hs-locale-management/static-1.106",
      "csstype": "/csstype/static-1.50",
      "quartz-head": "/quartz-head/static-1.736",
      "quick-fetch": "/quick-fetch/static-1.3941",
      "web-vitals": "/web-vitals/static-1.6",
      "quartz-routing": "/quartz-routing/static-1.501",
      "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1-cwunder-lower-max-network-payload-size.9",
      "bender-build-tools": "/bender-build-tools/static-1.3227",
      "dispatcher": "/dispatcher/static-1.137",
      "general-store": "/general-store/static-6.20",
      "hub-http-janus": "/hub-http-janus/static-1.838",
      "hubspotter-http": "/hubspotter-http/static-1.4676",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.538",
      "module-federation": "/module-federation/static-1.23",
      "quartz-auth": "/quartz-auth/static-1.746",
      "quartz-test": "/quartz-test/static-1.746",
      "quartz-tracking": "/quartz-tracking/static-1.450",
      "usage-tracker-container": "/usage-tracker-container/static-1-cwunder-lower-max-network-payload-size.9",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2935",
      "foundations-theming-base": "/foundations-theming-base/static-1.3437",
      "stylex": "/stylex/static-1.33",
      "apollo-dlb": "/apollo-dlb/static-3.86",
      "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4684",
      "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9858",
      "FileManagerCore": "/FileManagerCore/static-1.39218",
      "FileManagerLib": "/FileManagerLib/static-1.39359",
      "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4911",
      "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
      "salesImages": "/salesImages/static-1.525",
      "timezone-utils": "/timezone-utils/static-2.5277",
      "ui-gdpr-components": "/ui-gdpr-components/static-1.10383",
      "ts-schema": "/ts-schema/static-1.4105",
      "ai-components-ui-library": "/ai-components-ui-library/static-1.9061",
      "avatar-components": "/avatar-components/static-1.2531",
      "content-assistance-lib": "/content-assistance-lib/static-1.7800",
      "crm-component-utils": "/crm-component-utils/static-1.39182",
      "crm-display-components": "/crm-display-components/static-1.24932",
      "crm-fe-perf": "/crm-fe-perf/static-1.22936",
      "crm-links": "/crm-links/static-1.6333",
      "crm-message-bus": "/crm-message-bus/static-1.43071",
      "crm-search-service-types": "/crm-search-service-types/static-1.1187",
      "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5376",
      "customer-data-communicator": "/customer-data-communicator/static-1.45650",
      "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39932",
      "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13062",
      "customer-data-properties": "/customer-data-properties/static-1.51697",
      "customer-data-rte": "/customer-data-rte/static-1.33097",
      "draft-plugins": "/draft-plugins/static-2.21731",
      "file-manager-components": "/file-manager-components/static-1.23719",
      "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6918",
      "frontend-preferences-client": "/frontend-preferences-client/static-1.7960",
      "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18336",
      "object-comments-thread-lib": "/object-comments-thread-lib/static-1.10762",
      "prosemirror-user-and-team-at-mentions": "/prosemirror-user-and-team-at-mentions/static-1.673",
      "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8128",
      "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18046",
      "universal-associations-select": "/universal-associations-select/static-1.11072",
      "universal-record-utils-lib": "/universal-record-utils-lib/static-1.1015",
      "wootric-nps": "/wootric-nps/static-1.7006",
      "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3871",
      "property-translator": "/property-translator/static-1.5431",
      "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.95",
      "chirp-fetch": "/chirp-fetch/static-1.1920",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10050",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10048",
      "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1-cwunder-lower-max-network-payload-size.9",
      "react-dnd-compat": "/react-dnd-compat/static-1.4647",
      "audio-components": "/audio-components/static-1.5963",
      "cropperjs": "/cropperjs/static-1.10",
      "feedback-loader": "/feedback-loader/static-1.29358",
      "FileManagerImages": "/FileManagerImages/static-1.36870",
      "foundations-components-legacy": "/foundations-components-legacy/static-1.1023",
      "immerable": "/immerable/static-1.4186",
      "react-colorpicker": "/react-colorpicker/static-2.10240",
      "ui-universal-auth": "/ui-universal-auth/static-1.9016",
      "video-components": "/video-components/static-1.13417",
      "video-data-lib": "/video-data-lib/static-1.35072",
      "video-embed": "/video-embed/static-1.35906",
      "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.370",
      "chatspot-core": "/chatspot-core/static-1.21442",
      "ContentUtils": "/ContentUtils/static-1.68476",
      "copilot-toolkit": "/copilot-toolkit/static-1.11224",
      "superstore": "/superstore/static-1.4793",
      "ui-addon-video-player": "/ui-addon-video-player/static-1.8735",
      "ui-coaching-tips": "/ui-coaching-tips/static-1.28667",
      "card-properties-lib": "/card-properties-lib/static-1.44308",
      "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37232",
      "crm-actions": "/crm-actions/static-1.6365",
      "crm-cards-sdk": "/crm-cards-sdk/static-1.43703",
      "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9377",
      "customer-data-property-utils": "/customer-data-property-utils/static-1.8124",
      "customer-data-tracking": "/customer-data-tracking/static-1.6922",
      "hs-resources": "/hs-resources/static-1.189",
      "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3611",
      "pulse": "/pulse/static-1.612",
      "framework-data-table": "/framework-data-table/static-2.11996",
      "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9375",
      "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.997",
      "calling-error-reporting": "/calling-error-reporting/static-1.31342",
      "calling-internal-common": "/calling-internal-common/static-1.31335",
      "calling-usage-tracker": "/calling-usage-tracker/static-1.6573",
      "crm_data": "/crm_data/static-4.92081",
      "customer-data-content": "/customer-data-content/static-1.27348",
      "draft-content-plugins": "/draft-content-plugins/static-1.28369",
      "draft-convert": "/draft-convert/static-2.73",
      "draft-extend": "/draft-extend/static-3.75",
      "draft-js": "/draft-js/static-5.78",
      "draft-signature-plugin": "/draft-signature-plugin/static-1.24169",
      "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24450",
      "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18328",
      "integration-settings-components": "/integration-settings-components/static-1.15581",
      "integrations-lib": "/integrations-lib/static-1.16286",
      "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5635",
      "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7814",
      "nav-meta": "/nav-meta/static-1.29767",
      "onboarding-scopes": "/onboarding-scopes/static-1.6493",
      "outreach-assistant-email-generation": "/outreach-assistant-email-generation/static-1.6292",
      "prosemirror-copilot": "/prosemirror-copilot/static-1.11711",
      "prosemirror": "/prosemirror/static-1.13",
      "quotes-client-types": "/quotes-client-types/static-1.38258",
      "reference-resolvers": "/reference-resolvers/static-1.8204",
      "rich-text-lib": "/rich-text-lib/static-1.19888",
      "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3877",
      "sequences-lib": "/sequences-lib/static-1.8099",
      "ui-addon-i18n": "/ui-addon-i18n/static-1.11181",
      "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9093",
      "ui-business-units-lib": "/ui-business-units-lib/static-1.9089",
      "ui-shepherd-react": "/ui-shepherd-react/static-3.10205",
      "user-context": "/user-context/static-1.5138",
      "whatsapp-sending-lib": "/whatsapp-sending-lib/static-1.5821",
      "events-data-lib": "/events-data-lib/static-1.258",
      "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.22367",
      "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13199",
      "FormUrlGenerator": "/FormUrlGenerator/static-2.4751",
      "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4030",
      "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6823",
      "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1013",
      "onboarding-tours": "/onboarding-tours/static-1.16672",
      "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13788",
      "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
      "ui-addon-teams": "/ui-addon-teams/static-1.21603",
      "calling-global-api": "/calling-global-api/static-1.64637",
      "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66019",
      "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58313",
      "commerce-products-lib": "/commerce-products-lib/static-1.9701",
      "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3822",
      "external-options-client-types": "/external-options-client-types/static-1.4184",
      "google-libphonenumber": "/google-libphonenumber/static-1.38",
      "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4248",
      "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.664",
      "multi-currency-client-types": "/multi-currency-client-types/static-1.3716",
      "object-builder-ui-client": "/object-builder-ui-client/static-1.48873",
      "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3990",
      "property-value-citations": "/property-value-citations/static-1.2311",
      "smart-property-lib": "/smart-property-lib/static-1.7275",
      "tiered-pricing": "/tiered-pricing/static-1.1296",
      "zustand": "/zustand/static-1.74",
      "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11022",
      "video-components-external": "/video-components-external/static-1.11414",
      "batch-promise": "/batch-promise/static-1.1574",
      "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4164",
      "fdsr-migration-layer": "/fdsr-migration-layer/static-1.37",
      "persist-promise": "/persist-promise/static-1.3731",
      "emoji-mart": "/emoji-mart/static-3.4",
      "growth-payments-core": "/growth-payments-core/static-1.25489",
      "knowledge-content-types": "/knowledge-content-types/static-1.8504",
      "payment-link-components": "/payment-link-components/static-1.23622",
      "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9920",
      "call-summary": "/call-summary/static-1.39327",
      "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10196",
      "laboratory-lib": "/laboratory-lib/static-3.7188",
      "merchandise-lib": "/merchandise-lib/static-1.264",
      "purchase-motions-components": "/purchase-motions-components/static-1.5979",
      "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.9653",
      "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
      "react-dnd": "/react-dnd/static-5.6",
      "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
      "unified-auth-core-lib": "/unified-auth-core-lib/static-1.812",
      "content-icons-ui": "/content-icons-ui/static-1.2233",
      "social-insights-client-types": "/social-insights-client-types/static-1.22215",
      "outpost": "/outpost/static-1.4211",
      "markdown-it": "/markdown-it/static-1.6",
      "cms-field-types": "/cms-field-types/static-1.4845",
      "underscore": "/underscore/static-1.8",
      "magpie-lib": "/magpie-lib/static-1.5572",
      "magpie-types": "/magpie-types/static-1.5032",
      "simple-logging-lib": "/simple-logging-lib/static-1.3083",
      "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6612",
      "customer-data-sidebar": "/customer-data-sidebar/static-2.46122",
      "enrichment-properties-lib": "/enrichment-properties-lib/static-1.16393",
      "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4289",
      "commerce-billing-lib": "/commerce-billing-lib/static-1.19193",
      "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.18634",
      "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.10477",
      "bend-plugin-pulse": "/bend-plugin-pulse/static-1.115",
      "event-emitter": "/event-emitter/static-1.980",
      "fast-json-patch": "/fast-json-patch/static-1.63",
      "customer-data-associations": "/customer-data-associations/static-1.7359",
      "reporting-data": "/reporting-data/static-1.67711",
      "tanstack-virtual": "/tanstack-virtual/static-1.30",
      "ui-addon-draggable": "/ui-addon-draggable/static-3.4795",
      "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3615",
      "self-service-api": "/self-service-api/static-1.10280",
      "crm_universal": "/crm_universal/static-1.22062",
      "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9300",
      "content-embed-lib": "/content-embed-lib/static-1.7371",
      "data-model-builder-lib": "/data-model-builder-lib/static-1.12459",
      "remote-ui": "/remote-ui/static-1.65",
      "ui-components-test-utils": "/ui-components-test-utils/static-1.5642",
      "ui-extensions-remote-renderer": "/ui-extensions-remote-renderer/static-1.17126",
      "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3046",
      "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13701",
      "redux-observable": "/redux-observable/static-1.11",
      "ReduxMessenger": "/ReduxMessenger/static-2.10398",
      "rxjs": "/rxjs/static-5.10",
      "unified-auth": "/unified-auth/static-1.530",
      "messaging-types-lib": "/messaging-types-lib/static-1.46121",
      "ai-addon-copilot-preview": "/ai-addon-copilot-preview/static-1.8273",
      "copilot-plugins": "/copilot-plugins/static-1.11197",
      "data-token-picker": "/data-token-picker/static-1.16462",
      "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7956",
      "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5481",
      "navigation-messaging": "/navigation-messaging/static-1.7457",
      "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18550",
      "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17668",
      "onboarding-tours-utils": "/onboarding-tours-utils/static-1.738",
      "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.1246",
      "whatsapp-management-lib": "/whatsapp-management-lib/static-1.8980",
      "growth-data-modal": "/growth-data-modal/static-1.5477",
      "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3099",
      "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2031",
      "navigation-components": "/navigation-components/static-1.18130",
      "onboarding-tours-client": "/onboarding-tours-client/static-1.4886",
      "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7586",
      "shared-worker-versioning": "/shared-worker-versioning/static-1.11069",
      "voice-sms-access-library": "/voice-sms-access-library/static-1.1149",
      "commerce-permissions": "/commerce-permissions/static-1.805",
      "products-iframe-lib": "/products-iframe-lib/static-1.8040",
      "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10432",
      "data-agent-kit": "/data-agent-kit/static-1.244",
      "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10133",
      "fsm": "/fsm/static-1.3764",
      "policy-lib": "/policy-lib/static-1.6809",
      "react-tinymce": "/react-tinymce/static-1.55351",
      "tinymce": "/tinymce/static-5.11",
      "tinymce-config": "/tinymce-config/static-2.54477",
      "tinymce-plugins": "/tinymce-plugins/static-1.57591",
      "tinymce-themes": "/tinymce-themes/static-1.56447",
      "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12455",
      "content-media-compositions": "/content-media-compositions/static-2.16462",
      "idb-keyval": "/idb-keyval/static-1.44",
      "media-bridge-lib": "/media-bridge-lib/static-1.18981",
      "seat-types-lib": "/seat-types-lib/static-1.96",
      "ui-addon-opt": "/ui-addon-opt/static-4.8395",
      "commerce-tours-lib": "/commerce-tours-lib/static-1.6166",
      "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5114",
      "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3675",
      "calling-cross-tab-library": "/calling-cross-tab-library/static-1.19320",
      "calling-lifecycle-usage-tracker": "/calling-lifecycle-usage-tracker/static-1.8805",
      "purchase-motions-api": "/purchase-motions-api/static-1.5982",
      "reactive-lib": "/reactive-lib/static-1.755",
      "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.37286",
      "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.39655",
      "commerce-contract-lib": "/commerce-contract-lib/static-1.12219",
      "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.54843",
      "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.21573",
      "products-highlight-card-lib": "/products-highlight-card-lib/static-1.17984",
      "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.72168",
      "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.9078",
      "utility-belt": "/utility-belt/static-1.2566",
      "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.23009",
      "stripe-embedded-components": "/stripe-embedded-components/static-1.7561",
      "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5796",
      "InboxConnectUtils": "/InboxConnectUtils/static-4.14918",
      "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5141",
      "qrcode-generator": "/qrcode-generator/static-1.69",
      "trials-service-types": "/trials-service-types/static-1.3937",
      "reporting-client-types": "/reporting-client-types/static-1.2508",
      "react-flip-move": "/react-flip-move/static-1.70",
      "FireAlarmUi": "/FireAlarmUi/static-1.4537",
      "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4195",
      "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11082",
      "association-settings-lib": "/association-settings-lib/static-1.10389",
      "collaboration-sidebar": "/collaboration-sidebar/static-1.57918",
      "conditional-property-settings-modal": "/conditional-property-settings-modal/static-1.12524",
      "data-model-commons-lib": "/data-model-commons-lib/static-1.12722",
      "ExportDialog": "/ExportDialog/static-6.10417",
      "final-form": "/final-form/static-1.70",
      "html-to-image": "/html-to-image/static-1.54",
      "nudge-client-utils": "/nudge-client-utils/static-1.2656",
      "object-definition-builder-lib": "/object-definition-builder-lib/static-1.7136",
      "property-management-iframe": "/property-management-iframe/static-1.13281",
      "property-usages-lib": "/property-usages-lib/static-1.5473",
      "reactflow": "/reactflow/static-1.64",
      "simple-data-table": "/simple-data-table/static-1.2885",
      "used-in-list-lib": "/used-in-list-lib/static-1.6991",
      "visual-association": "/visual-association/static-1.5917",
      "highcharts": "/highcharts/static-8.104",
      "reporting-visualizations": "/reporting-visualizations/static-1.59787",
      "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3957",
      "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.351",
      "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.477",
      "slack-ui-library": "/slack-ui-library/static-1.10425",
      "automation-platform-service-types": "/automation-platform-service-types/static-1.2598",
      "ContentData": "/ContentData/static-1.68551",
      "email-portal-health-service-types": "/email-portal-health-service-types/static-1.1011",
      "marketing-email-service-types": "/marketing-email-service-types/static-1.1928",
      "ai-rendering-library": "/ai-rendering-library/static-1.10297",
      "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7934",
      "breeze-engine-lib": "/breeze-engine-lib/static-1.760",
      "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15434",
      "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.695",
      "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.865",
      "content-whatsapp-service-types": "/content-whatsapp-service-types/static-1.410",
      "marketing-platform-lib": "/marketing-platform-lib/static-1.6891",
      "short-messages-app-service-client": "/short-messages-app-service-client/static-1.4002",
      "ui-tool-access": "/ui-tool-access/static-1.10180",
      "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2006",
      "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2059",
      "user-context-client": "/user-context-client/static-1.4644",
      "nest": "/nest/static-1.262",
      "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35926",
      "sales-views-client-types": "/sales-views-client-types/static-1.4292",
      "trellis-story-utils": "/trellis-story-utils/static-1.4547",
      "storybook-react": "/storybook-react/static-1.33",
      "hub-http-contrib": "/hub-http-contrib/static-1.3074",
      "interframe": "/interframe/static-3.4792",
      "tinymce-data": "/tinymce-data/static-1.40562",
      "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5243",
      "codemirror": "/codemirror/static-5.95",
      "layout-dnd-components": "/layout-dnd-components/static-1.12505",
      "layout-dnd-utils": "/layout-dnd-utils/static-1.11480",
      "react-codemirror": "/react-codemirror/static-1.10658",
      "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9083",
      "js-cookie": "/js-cookie/static-1.18",
      "products-ui-components": "/products-ui-components/static-1.40219",
      "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7114",
      "invoices-ui-lib": "/invoices-ui-lib/static-1.54859",
      "commerce-products-api": "/commerce-products-api/static-1.2350",
      "invoices-iframe-lib": "/invoices-iframe-lib/static-1.56917",
      "quotes-modal-lib": "/quotes-modal-lib/static-1.102846",
      "quotes-ui-lib": "/quotes-ui-lib/static-1.80889",
      "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7696",
      "reporting-ui-components": "/reporting-ui-components/static-2.64982",
      "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14977",
      "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.18419",
      "stripe-connect-js": "/stripe-connect-js/static-1.69",
      "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9574",
      "nested-table": "/nested-table/static-1.259",
      "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.21433",
      "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.2715",
      "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5918",
      "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2413",
      "nudge-renderer-utils": "/nudge-renderer-utils/static-1.2732",
      "whisper-core-api": "/whisper-core-api/static-1.6733",
      "property-management-common": "/property-management-common/static-1.5569",
      "d3": "/d3/static-1.7",
      "advanced-menus-core": "/advanced-menus-core/static-1.15177",
      "advanced-menus-lib": "/advanced-menus-lib/static-1.12115",
      "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34152",
      "breeze-onboarding-components": "/breeze-onboarding-components/static-1.100",
      "embedded-academy-lib": "/embedded-academy-lib/static-1.14443",
      "highlight.js": "/highlight.js/static-1.79",
      "reporting-action-components": "/reporting-action-components/static-1.41402",
      "reporting-snowflake": "/reporting-snowflake/static-1.56329",
      "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7637",
      "diff-match-patch": "/diff-match-patch/static-1.7",
      "layout-data-lib": "/layout-data-lib/static-1.9805",
      "browser-eslint": "/browser-eslint/static-2.57",
      "commerce-tax-lib": "/commerce-tax-lib/static-1.561",
      "price-books-api": "/price-books-api/static-1.930",
      "price-books-components": "/price-books-components/static-1.988",
      "property-description-translator": "/property-description-translator/static-1.3875",
      "ramp-editor": "/ramp-editor/static-1.230",
      "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3663",
      "totals-ui-components": "/totals-ui-components/static-1.23710",
      "reporting-plugins": "/reporting-plugins/static-1.10375",
      "reporting-reports": "/reporting-reports/static-1.67389",
      "edison-service-client-types": "/edison-service-client-types/static-1.422",
      "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10544",
      "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.17294",
      "marketplace-ui-common": "/marketplace-ui-common/static-1.19887",
      "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8032",
      "react-window": "/react-window/static-1.13",
      "ts-utils-lib": "/ts-utils-lib/static-1.204",
      "seamless-immutable": "/seamless-immutable/static-7.6",
      "simple-menus-core": "/simple-menus-core/static-1.15176",
      "simple-menus-lib": "/simple-menus-lib/static-1.16693",
      "academy-common-lib": "/academy-common-lib/static-1.13903",
      "dashboard-lib": "/dashboard-lib/static-1.81674",
      "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8735",
      "line-items-api": "/line-items-api/static-1.750",
      "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3844",
      "campaign-roi-lib": "/campaign-roi-lib/static-1.9229",
      "apps-service-types": "/apps-service-types/static-1.3910",
      "oauth-service-types": "/oauth-service-types/static-1.4284",
      "academy-service-client": "/academy-service-client/static-1.3715",
      "croppie": "/croppie/static-2.10",
      "trellis-ecosystem": "/trellis-ecosystem/static-1.7200",
      "redux-actions": "/redux-actions/static-3.7"
    },
    "bundlingPackage": "conversations-visitor-ui",
    "bundlingPackageVersion": "static-1.29471",
    "project": "conversations-visitor-ui",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};